export default {
    title: "Registracija",
    subtitle: "Odaberite Vaše interesovanje",
    back: 'Nazad',
    seller: "Prodavac",
    buyer: "Kupac",
    deliverer: "Dostava",
    buttons: {
        register: "Registruj se",
        login: "Prijavi se",
    },
};
